module.exports = __webpack_public_path__ + "img/2022-LevelNext-FIFA-22-College-National-Championship.163d1d20.png";